import React, { useEffect, useState } from 'react';
import styles from './ShowroomStats.module.css';
import { BACKEND_URL } from '../config';

export default function ShowroomStats({ range }) {
  const [rows, setRows] = useState([]);
  const [showAll, setShowAll] = useState(false);
  const [loading, setLoading] = useState(false);

  const fetchRows = (all = false) => {
    setLoading(true);
    const q = all
      ? `${BACKEND_URL}/api/report/showrooms?range=${range}`
      : `${BACKEND_URL}/api/report/showrooms?range=${range}&limit=10`;

    fetch(q)
      .then((res) => res.json())
      .then((data) => setRows(Array.isArray(data) ? data : []))
      .catch(console.error)
      .finally(() => setLoading(false));
  };

  useEffect(() => {
    fetchRows(showAll);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [range, showAll]);

  return (
    <div className={styles.showroomStatsContainer}>
      <div className={styles.header}>
        <h3 className={styles.title}>Showroom Order Stats</h3>
        <button
          className={styles.button}
          onClick={() => setShowAll((s) => !s)}
        >
          {showAll ? 'Collapse' : 'Show all'}
        </button>
      </div>

      {loading ? (
        <p className={styles.loadingText}>Loading...</p>
      ) : (
        <div className={styles.tableContainer}>
          <table className={styles.table}>
            <thead className={styles.tableHead}>
              <tr>
                <th className={styles.tableHeadTh}>Showroom</th>
                <th className={styles.tableHeadTh}>Total Orders</th>
                <th className={styles.tableHeadTh}>Pending Orders</th> {/* NEW */}
                <th className={styles.tableHeadTh}>Avg Delivery Time</th>
              </tr>
            </thead>

            <tbody>
              {rows.length === 0 ? (
                <tr>
                  <td colSpan="4" className={styles.noDataCell}>No data</td>
                </tr>
              ) : (
                rows.map((r) => (
                  <tr key={r.showroom_id} className={styles.tableRow}>
                    <td className={styles.showroomName}>{r.showroom_name}</td>
                    <td className={styles.tableData}>{r.total_orders}</td>
                    <td className={styles.tableData}>{r.pending_orders ?? '-'}</td> {/* NEW */}
                    <td className={styles.tableData}>{r.avg_delivery_time || '-'}</td>
                  </tr>
                ))
              )}
            </tbody>
          </table>
        </div>
      )}
    </div>
  );
}
